import { Box, List, Collapse } from '@mui/material';
import { SectionHeader } from './SectionHeader';
import { NavigationItem } from './NavigationItem';
import { EmptyState } from './EmptyState';
import { ViewAllProductsLink } from './ViewAllProductsLink';
import { useFeatureFlag, FeatureFlagKey } from '../../hooks/useFeatureFlags';
import { MenuSectionTitle, type MenuSection } from '../../types';

interface NavigationSectionProps {
  section: MenuSection;
  isExpanded: boolean;
  onToggle: () => void;
  onItemClick: () => void;
}

export function NavigationSection({
  section,
  isExpanded,
  onToggle,
  onItemClick,
}: NavigationSectionProps) {
  const hasItems = section.items.length > 0;
  const allProductsEnabled = useFeatureFlag(FeatureFlagKey.PSP_UI_ALL_PRODUCTS_PAGE);
  const showViewAllProducts = allProductsEnabled && section.title === MenuSectionTitle.PRODUCTS;

  return (
    <Box>
      <SectionHeader section={section} isExpanded={isExpanded} onToggle={onToggle} />
      {section.collapsible ? (
        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
          <List disablePadding>
            {hasItems ? (
              section.items.map((item) => (
                <NavigationItem key={item.path} item={item} onItemClick={onItemClick} />
              ))
            ) : (
              <EmptyState />
            )}
            {showViewAllProducts && <ViewAllProductsLink onNavigate={onItemClick} />}
          </List>
        </Collapse>
      ) : (
        <List disablePadding>
          {section.items.map((item) => (
            <NavigationItem key={item.path} item={item} onItemClick={onItemClick} />
          ))}
          {showViewAllProducts && <ViewAllProductsLink onNavigate={onItemClick} />}
        </List>
      )}
    </Box>
  );
}
